/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["button[_ngcontent-%COMP%]{float:right;margin:0;padding:1px}.btn-container[_ngcontent-%COMP%]{position:absolute;top:-2px;right:0}.btn-xs[_ngcontent-%COMP%]{width:20px;height:20px;max-height:20px}.btn-xs[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:.9em}"];
export { styles as styles };
